export default __webpack_public_path__ + "static/media/process.b6f158bf.png";